export class CardReader {
    ID?: number;
    Name?: string;
}

export default CardReader;